import {
  RENEWABLE_ENERGY_ICON,
  MEASUREMENT_REGULATION_ICON,
  WATER_MANAGEMENT_ICON,
  SERVICE_ICON,
  ENERGY_ICON,
  CENTRAL_DISPATCHING_ICON,
} from "@/components/icons/icons";
import { ImagesEnum } from "@/model/enum/ImagesEnum";
import { RoutesEnum } from "@/model/enum/RoutesEnum";
import { SolutionTypeEnum } from "@/model/enum/SolutionTypeEnum";

export const obnovitelneZdroje = {
  nameKey: "solutions:obnovitelneZdroje.name",
  descriptionKey: "solutions:obnovitelneZdroje.description",
  href: `${RoutesEnum.SOLUTIONS}/${SolutionTypeEnum.OBNOVITELNE_ZDROJE_ENERGIE}`,
  imageUrl: ImagesEnum.ZELIEZOVCE,
  icon: RENEWABLE_ENERGY_ICON,
  type: SolutionTypeEnum.OBNOVITELNE_ZDROJE_ENERGIE,

  detailsPageHeroDescriptionKey:
    "solutions:obnovitelneZdroje.detailsPageHeroDescription",
  experienceKey: "solutions:obnovitelneZdroje.experience",
  experiencePointsKey: "solutions:obnovitelneZdroje.experiencePoints",
  ourFocusDescriptionKey: "solutions:obnovitelneZdroje.ourFocusDescription",
  ourFocusPoints: [
    {
      icon: MEASUREMENT_REGULATION_ICON,
      titleKey: "solutions:obnovitelneZdroje.ourFocusPoints.0.title",
      descriptionKey:
        "solutions:obnovitelneZdroje.ourFocusPoints.0.description",
    },
    {
      icon: WATER_MANAGEMENT_ICON,
      titleKey: "solutions:obnovitelneZdroje.ourFocusPoints.1.title",
      descriptionKey:
        "solutions:obnovitelneZdroje.ourFocusPoints.1.description",
    },
    {
      icon: SERVICE_ICON,
      titleKey: "solutions:obnovitelneZdroje.ourFocusPoints.2.title",
      descriptionKey:
        "solutions:obnovitelneZdroje.ourFocusPoints.2.description",
    },
    {
      icon: ENERGY_ICON,
      titleKey: "solutions:obnovitelneZdroje.ourFocusPoints.3.title",
      descriptionKey:
        "solutions:obnovitelneZdroje.ourFocusPoints.3.description",
    },
    {
      icon: CENTRAL_DISPATCHING_ICON,
      titleKey: "solutions:obnovitelneZdroje.ourFocusPoints.4.title",
      descriptionKey:
        "solutions:obnovitelneZdroje.ourFocusPoints.4.description",
    },
  ],
  section: null,
  sectionWithImage: null,
  solutionsForTopic: [
    {
      titleKey: "solutions:obnovitelneZdroje.solutionsForTopic.title",
      descriptionKey:
        "solutions:obnovitelneZdroje.solutionsForTopic.description",
      pointsKey: "solutions:obnovitelneZdroje.solutionsForTopic.points",
    },
  ],
};
